import React, { useState, useEffect } from "react";
import { Header } from "../../../components/user-dashboard/header";
import { Sidebar } from "../../../components/user-dashboard/sidebar";
import { useNavigate } from "react-router-dom";
import { AdminService } from "../../../app/service/admin.service";
import { toast } from "react-toastify";

const ManageResultList = () => {
  const [filteredRegisters, setFilteredRegisters] = useState([]);
  const navigate = useNavigate();

 

  useEffect(() => {
    getRegisters();
  }, []);

  const getRegisters = () => {
    const data = {
      search: "",
      start: 1,
      count: 10,
      type: "registerNow",
    };
    AdminService.allCollege(data).then((res: any) => {
      if (res.status === "Success") {
        setFilteredRegisters(res.data);
      } else {
        toast.error(res.message);
      }
    });
  };
  const handleClick = (college: any) => {
    navigate(`/exam/resultList/${college._id}`);
  };

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <Header />
        </div>
        <div className="row">
          <div className="col-md-2 h-100 px-0">
            <Sidebar />
          </div>
          <div className="col-md-10 content-scroll content-bg px-3 py-3">
            <h4 className="mb-4">College List</h4>

            <div className="row">
              {filteredRegisters?.map((college: any) => (
                <div
                  className="col-md-4 mb-4"
                  key={college._id}
                  onClick={() => handleClick(college)}
                >
                  <div className="card shadow h-100">
                    <div className="card-body">
                      <h5 className="card-title">{college.collegeName}</h5>

                      <p className="card-text">{college.description}</p>
                      <small className="text-muted">
                        Created:{" "}
                        {new Date(college.createdAt).toLocaleDateString()}
                      </small>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {filteredRegisters.length === 0 && (
              <div className="text-center mt-5">
                <h5>No Colleges Found</h5>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageResultList;
